import { css } from '@emotion/css';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { FormalConfirmButton } from 'src/components/shared/buttons/FormalConfirmButton';
import { ReportOverlayContainer } from 'src/components/shared/report/ReportOverlayContainer';
import { RootState } from 'src/features';
import { resortInfoSelector } from '../../selectors/resortInfoSelector';
import { ReportConstListItem } from './ReportConstListItem';

interface ReportSelectConstProps {
  basePath: string;
}

export const ReportSelectConst: React.FC<ReportSelectConstProps> = ({ basePath }) => {
  const { t } = useTranslation(['resort', 'translation']);
  const history = useHistory();
  const infoState = useSelector(resortInfoSelector);
  const { unlockFlags } = useSelector((state: RootState) => state.user);
  const [selectedId, setSelectedId] = useState<string | undefined>(undefined);

  const handleSelectedIdChange = useCallback((resortId: string) => setSelectedId(resortId), [
    setSelectedId
  ]);

  if (infoState?.state !== 'ok' || !unlockFlags) {
    return <></>;
  }

  const { profile, isFollowing } = infoState.result;

  const handleConfirmClick = () => {
    if (selectedId) {
      history.replace(`${basePath}/report?resort-id=${selectedId}&follow=${isFollowing}`);
    }
  };

  // 操作中のプレイヤーがツクッターの利用権利を持たない場合、画面に表示される施工事例が先頭2件だけなので
  // 通報対象として選択できる施工事例も先頭2件のみにする
  const constructions =
    unlockFlags.hasAoc && unlockFlags.isUnlockedResortAppNet
      ? profile.constructions
      : profile.constructions.slice(0, 2);

  return (
    <ReportOverlayContainer
      title={t('report_resort')}
      backButtonLabel={t('translation:aria_button_back_to_previous')}
    >
      <div
        className={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
          .select-construction {
            flex: 1 1 auto;
            width: 100%;
            max-width: 480px;
            margin: 0 auto;
            padding: 12px;
            overflow-y: scroll;
          }
          .desc {
            font-size: 14px;
            color: #938666;
          }
          .bottom-container {
            background: #f5f1e3;
            flex: 0 0 auto;
            .button {
              width: 100%;
              max-width: 480px;
              margin: 0 auto;
              padding: 12px 12px 24px;
            }
          }
        `}
      >
        <div className="select-construction">
          <p className="desc">{t('report_resort_select')}</p>
          <ul className="construction-grid">
            {constructions.map((construction, index) => (
              <ReportConstListItem
                key={index}
                construction={construction}
                onChange={handleSelectedIdChange}
              />
            ))}
          </ul>
        </div>
        <div className="bottom-container">
          <div className="button">
            <FormalConfirmButton isDisabled={!selectedId} onClick={handleConfirmClick}>
              {t('translation:button_next')}
            </FormalConfirmButton>
          </div>
        </div>
      </div>
    </ReportOverlayContainer>
  );
};
